import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { DateTime } from 'luxon';

import { useAppDispatch, useAppSelector } from '~/store/hooks';

interface AppointmentSliceState {
  appointmentCurrentDate: string;
}

const initialState: AppointmentSliceState = {
  appointmentCurrentDate: DateTime.fromJSDate(new Date()).toString(),
};

export const appointmentSlice = createSlice({
  initialState,
  name: 'appointment',
  reducers: {
    setAppointmentCurrentDate: (state, action: PayloadAction<string>) => {
      state.appointmentCurrentDate = action.payload;
    },
  },
});

export const { setAppointmentCurrentDate: setAppointmentCurrentDateAction } =
  appointmentSlice.actions;

export default appointmentSlice.reducer;

export const useAppointmentSelector = () => {
  return useAppSelector((state) => state.appointment);
};

export const useAppointmentDispatch = () => {
  const dispatch = useAppDispatch();

  const setAppointmentCurrentDate = (date: string) => {
    dispatch(setAppointmentCurrentDateAction(date));
  };

  return {
    setAppointmentCurrentDate,
  };
};
